import React, { useContext } from 'react';
import { Tabs, Tab, Stack } from '@mui/material';
import { GBENSContext } from './GBENSContainer';

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const ReviewAndSubmitMenu = () => {
  const { setSubmitModalOpen, setDuplicateModalOpen, setDeleteShipmentModalOpen, isReadOnly } =
    useContext(GBENSContext);

  return (
    <Stack direction="row" gap={2} className="stepper-wrapper-tabs">
      <div className="rowWrapper col-container shipment-view shipment-view-review">
        <Tabs
          className="wrapper-tabs"
          orientation="vertical"
          value={0}
          onChange={() => {}}
          sx={{
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          }}
        >
          <div className="shipment-actions">Shipment Actions</div>
          <Tab
            label="Submit Shipment"
            onClick={() => setSubmitModalOpen(true)}
            {...a11yProps(1)}
            disabled={isReadOnly}
          />
          <Tab
            label="Duplicate this Shipment"
            onClick={() => setDuplicateModalOpen(true)}
            {...a11yProps(0)}
            disabled={isReadOnly}
          />
          <Tab
            label="Delete Shipment"
            onClick={() => setDeleteShipmentModalOpen(true)}
            {...a11yProps(1)}
            disabled={isReadOnly}
          />
        </Tabs>
      </div>
    </Stack>
  );
};

export default ReviewAndSubmitMenu;
